import React, { useState } from 'react'
import { Copy, Thrash } from '../../assets/svgs'
import { SVG_Eye_Outline, SVG_Rocket_2_Linear, SVG_Rocket_Linear, SVG_Text_Bold, SVG_Trash_Bin_Trash_Linear } from '@dev-mobligo/iconpack'
import CreateAction from '../operational/createAction';
import SecondaryButton from './SecondaryButton';
import ThemesModalNameChanger from '../../pages/DashboardPages/Modals/ThemesModalNameChanger';
import { useSelector } from 'react-redux';

function ThemeOptions({ theme, getThemes }) {
    const [isOpen, setIsOpen] = useState(false)
    const license = useSelector(state => state.myUserSlice?.license);
    const deleteTheme = async (themeId) => {


        const response = await CreateAction({
            method: "delete",
            path: `/mainTheme/${themeId}`,
            showPreLoader: true,
            isFileUploading: false,
            toastMessage: {
                success: "success"
            }

        }
        );
        if (response?.error) return
        getThemes()

    }
    const copyTheme = async (themeId) => {

        const response = await CreateAction({
            method: "post",
            path: `/copyMainTheme/${themeId}`,
            showPreLoader: true,
            isFileUploading: false,
            toastMessage: {
                success: "success"
            }
        }
        );
        if (response?.error) return

        getThemes()
        return { success: "" }


    }

    const setMainTheme = async (themeId) => {

        const response = await CreateAction({
            method: "patch",
            path: `/setMainTheme/${themeId}`,
            showPreLoader: true,
            isFileUploading: false,
            toastMessage: {
                success: "success"
            }

        }
        );

        if (response?.error) return

        getThemes()
        return { success: "" }

    }


    return (
        <div className='absolute group-hover:right-[15px] right-[-50px] top-[15px] flex flex-col gap-[15px] duration-300 z-[20]'>
            <div className='bg-white p-[5px] rounded-md cursor-pointer'>
                <SecondaryButton
                    classes={` rounded-lg text-[14px] text-[#7059EF] flex justify-center items-center font-medium  w-[24px] !border-0 !p-0
            ${""} `}
                    onClick={() => { copyTheme(theme?.id) }}
                    value={<Copy className={"hover:stroke-[#7059ef] duration-300    stroke-[#5E5873] shrink-0   fill-white stroke-2 w-[24px] h-[24px]"}></Copy>

                    }
                    confirmationMessage={"copyApp"}
                ></SecondaryButton>
            </div>

            {!theme.isMain &&

                <div className='bg-white p-[5px] rounded-md cursor-pointer'>
                    <SecondaryButton
                        classes={` rounded-lg text-[14px] text-[#7059EF] flex justify-center items-center font-medium  w-[24px] !border-0 !p-0
            ${""} `}
                        onClick={() => { deleteTheme(theme?.id) }}
                        value={<SVG_Trash_Bin_Trash_Linear className='hover:stroke-[#E23D47] duration-300  stroke-[#5E5873] stroke-[0.5px] shrink-0  w-[24px] h-[24px]'></SVG_Trash_Bin_Trash_Linear>

                        }
                        confirmationMessage={"deleteTheme"}
                    ></SecondaryButton>

                </div>
            }
            <div className='bg-white p-[5px] rounded-md cursor-pointer' onClick={() => { setIsOpen(true) }}>
                <SVG_Text_Bold className={"hover:stroke-[#7059ef] hover:fill-[#7059ef] duration-300    stroke-[#5E5873] shrink-0 stroke-[0.5px]  fill-[#5E5873] w-[24px] h-[24px]"}></SVG_Text_Bold>

            </div>
            {(!license?.isWebView || theme?.themeData?.[0]?.settings?.isWebView) &&

                <div className='bg-white p-[5px] rounded-md cursor-pointer' >
                    <SecondaryButton
                        classes={` rounded-lg text-[14px] text-[#7059EF] flex justify-center items-center font-medium  w-[24px] !border-0 !p-0
            ${""} `}
                        onClick={() => { setMainTheme(theme?.id) }}
                        value={<SVG_Rocket_Linear className={"hover:stroke-[#7059ef] duration-300    stroke-[#5E5873] shrink-0  stroke-[0.5px] fill-[#5E5873] w-[24px] h-[24px]"}></SVG_Rocket_Linear>


                        }
                        confirmationMessage={"isPublishApp"}
                    ></SecondaryButton>

                </div>
            }
            {isOpen && <ThemesModalNameChanger theme={theme} isOpen={isOpen} setIsOpen={setIsOpen} getThemes={getThemes}></ThemesModalNameChanger>}

        </div>
    )
}

export default ThemeOptions